import { render, staticRenderFns } from "./algo-task-two.html?vue&type=template&id=36b02689&scoped=true&"
import script from "./algo-task-two.js?vue&type=script&lang=js&"
export * from "./algo-task-two.js?vue&type=script&lang=js&"
import style0 from "./algo-task-two.scss?vue&type=style&index=0&id=36b02689&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b02689",
  null
  
)

export default component.exports